import styled, { css } from 'styled-components';
import { SvgIcon, Button, Dropdown, LoaderAnimated } from '@insly/qmt-reactjs-ui-lib';
import { Link } from 'react-router-dom';
import { DefaultIcon } from 'styles/common';
import { Badge } from './partials/Notifications/styles';

const breakpointCollapsedMenu = '1070px';

const DropdownItem = css`
  display: flex;
  align-items: center;
  padding: 16px;
  ${({ theme }) => theme.text.normal};
  color: ${({ theme }) => theme.colors.text};
  text-decoration: none;
`;

export const NavLinkIcon = styled(SvgIcon)`
  display: block;
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
  &:hover {
    transform: translateY(-3px);
  }
`;

export const NavLinkTitle = styled.span`
  display: none;
`;

export const NavLinkStyled = styled(Link)`
  ${({ theme }) => theme.text.normal};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.text};
  text-decoration: none;
  margin-right: 24px;
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
  &.selected {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const Header = styled.header`
  padding: 8px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.strokeB};
  
  @media (min-width: ${breakpointCollapsedMenu}) {
    ${NavLinkStyled} {
      margin-right: 32px;
    }
    ${NavLinkIcon} {
      display: none;
    }
    ${NavLinkTitle} {
      display: block;
    }
  }
`;

export const Nav = styled.nav`
  display: flex;
`;

export const ButtonAddNew = styled(Button)`
  span {
    margin-right: 8px;
  }
  .qmt-ui-svg-icon {
    width: 24px;
    height: 24px;
    stroke: ${({ theme }) => theme.colors.white};
  }
`;

export const Tools = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  grid-template-columns: repeat(4, auto);
  grid-template-rows: 1fr;
  gap: 0 8px;
  .qmt-ui-search {
    transition: all 0.3s ease;
    height: 36px;
    &--active,
    &--has-value {
      flex: auto;
    }
  }
`;

export const DropdownItemIcon = styled(SvgIcon)<{margin?: 'left' | 'right'}>`
  width: 24px;
  height: 24px;
  fill: ${({ theme }) => theme.colors.black};
  stroke: ${({ theme }) => theme.colors.black};
  margin-right: ${({ margin }) => margin === 'right' ? '16px' : null };
  margin-left: ${({ margin }) => margin === 'left' ? '16px' : null };
`;

export const ButtonPicker = styled(Button)`
  position: relative;
  background-color: #F0F0F0;
  padding-left: 12px;
  padding-right: 12px;
  &:hover {
    background-color: #E2E2E2;
    border-color: #E2E2E2;
  }
  .qmt-ui-svg-icon {
    width: 24px;
    height: 24px;
    fill: ${({ theme }) => theme.colors.black};
    stroke: ${({ theme }) => theme.colors.black};
  }
`;

export const HeaderDropdown = styled(Dropdown)`
  &.qmt-ui-dropdown--opened {
    ${ButtonPicker} {
      background-color: ${({ theme }) => theme.colors.black};
      border-color: ${({ theme }) => theme.colors.black};
      .qmt-ui-svg-icon {
        width: 24px;
        height: 24px;
        fill: ${({ theme }) => theme.colors.white};
        stroke: ${({ theme }) => theme.colors.white};
      }
      ${Badge} {
        border-color: ${({ theme }) => theme.colors.black};
      }
    }
  }
  
  .qmt-ui-dropdown__drop {
    top: calc(100% + 16px);
  }
`;

export const UserData = styled.div`
  display: flex;
  align-items: center;
  padding-left: 10px;
`;

export const UserDataString = styled.div`
  ${({ theme }) => theme.text.normal};
  text-align: end;
  margin-right: 16px;
`;

export const UserDataStringSecondary = styled(UserDataString)`
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const UserDropDown = styled.ul`
  width: 240px;
`;

export const DropdownItemWrapper = styled.li`
  transition: background-color 0.3s ease;
  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.strokeB};
  }
  &:last-child {
    border-radius: 0 0 ${({ theme }) => theme.borderRadius} ${({ theme }) => theme.borderRadius};
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.hoverGray};
  }
`;

export const UserDropdownItemWrapper = styled(DropdownItemWrapper)`
  &:first-child {
    border-radius: ${({ theme }) => theme.borderRadius} ${({ theme }) => theme.borderRadius} 0 0;
  }
`;

export const UserDropdownItemSpan = styled.span`
  ${DropdownItem};
  cursor: pointer;
`;

export const UserDropdownItemLabel = styled.span`
  ${({ theme }) => theme.text.normal};
  margin-left: auto;
`;

export const Loader = styled(LoaderAnimated)`
  width: 22px;
  height: 22px;
  flex-shrink: 0;
`;

export const IconRemoveMasking = styled(DefaultIcon)`
  width: 14px;
  height: 14px;
  flex-shrink: 0;
`;
